import script from "./IntegralScreeBox.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegralScreeBox.vue?vue&type=script&setup=true&lang=js"

import "./IntegralScreeBox.vue?vue&type=style&index=0&id=b81c1900&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b81c1900"]])

export default __exports__